import ThreeWindingTransformers from "../classes/ThreeWindingTransformer"
import { Position } from 'reactflow'

export const threeWindingTransformers = [
  new ThreeWindingTransformers(
    {
      alias:"transfomador-de-3-devanados-Base",  
      svgSrc: "/assets/editor-symbols/TransformadorTresDevanadosBase.svg", 
      label: "3 devanados", 
      rotable: true,
      handles: [
        {
          id: "ctr1",
          type: "target",
          position: Position.Top
        },
        {
          id: "3e7701ff",
          type: "source",
          position: Position.Bottom,
          gridAlign: { count: 2, index: 0 }
        },
        {
          id: "851d",
          type: "source",
          position: Position.Bottom,
          gridAlign: { count: 2, index: 1 }
        }                
      ]
    }),
];
